import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import {
  TextInput, IntInput
} from "components/Input/Index.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { lorawanthreadtext } from "variables/MBM/lorawanthread";
import { postLorawanthread, putLorawanthread } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { lorawanthreadtypeData } from "variables/MBM/lists/lorawanthread";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function LorawanThreadDialog(props) {
  const { closeModal, refetch, currentLorawanThread } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [servertype, setServertype] = useState(currentLorawanThread?.servertype || "");
  const [frequency, setFrequency] = useState(currentLorawanThread?.frequency || 1);
  const [groups, setGroups] = useState(currentLorawanThread?.groupid ? "" + currentLorawanThread.groupid : "");


  const [buttonDisabled, setButtonDisabled] = useState(true);


  useEffect(() => {
    if (
      servertype &&
      (groups.length > 0 && groups !== "0") &&
      frequency
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [servertype, groups, frequency]);


  const handleSubmit = async (event) => {
    if (currentLorawanThread)
      updateLorawanThread(event);
    else
      createLorawanThread(event);
  };

  const handleServertypeChange = (event) => { setServertype(event.target.value); };
  const handleFrequencyChange = (event) => { setFrequency(event.target.value); };


  const createLorawanThread = async (event) => {
    await axios
      .post(
        postLorawanthread(),
        {
          groups,
          servertype,
          frequency
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Thread LoRaWAN créé");
        } else setNotification("error", res.data.message);
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error.response);
        setNotification("error", "Une erreur est survenue : " + error.response?.data?.message);
      });
  };

  const updateLorawanThread = async (event) => {

    await axios
      .put(
        putLorawanthread(currentLorawanThread.id),
        {
          groups,
          servertype,
          frequency
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Thread LoRaWAN modifié");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <CustomSelect
                inputTitle={lorawanthreadtext.servertype}
                selectValue={servertype}
                handleSelectValueChange={handleServertypeChange}
                data={lorawanthreadtypeData}
              />
            </div>
            <div>
              <IntInput
                isRequired
                inputTitle={lorawanthreadtext.frequency}
                intInput={frequency}
                handleIntInputChange={handleFrequencyChange}
              />
            </div>
          </GridItem>

          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={chartIdGroup[0]}
                />
              </ImageList>
            </div>
          </GridItem>

        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentLorawanThread ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default LorawanThreadDialog;
